import { render, staticRenderFns } from "./list-a07213a1.vue?vue&type=template&id=1def1d4e&"
import script from "./list-a07213a1.vue?vue&type=script&lang=js&"
export * from "./list-a07213a1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports